import { Avatar, Box, Chip, List, ListItem, ListItemAvatar, ListItemButton, ListItemText } from "@mui/material";
import { Funcionario } from "../../funcionario/funcionario.model";
import { CheckCircle, Image, Moped, PausePresentation } from "@mui/icons-material";
import { useEffect } from "react";
import { CanalDistribuicaoViewProps } from "../canalDist.controll";
import { formatData } from "../../../services/utils";
import { CanalDistribuicao } from "../canalDist.model";


export function CanalDistList(props: CanalDistribuicaoViewProps) {
    const { rows, row} = props.canalDistribuicaoState
    const { set } = props.canalDistribuicaoActions

    console.log("canal dist state", props.canalDistribuicaoState)
    
    const chipStatusCanal = (row:CanalDistribuicao) => {
        switch (row.situacao) {
            case "PENDENTE":  
                return <Chip label="Pendente" size="small" deleteIcon={<PausePresentation />} color="warning"/>
            case "ABERTO":
                return <Chip label="Aberto" size="small" deleteIcon={<Moped />} color="info"/>
            default:
                return <Chip label="Fechado" size="small" deleteIcon={<CheckCircle />} color="success"/>
        }
    }
    return (
        <Box sx={{ display: "flex", flex: 1 }}>
            <List dense sx={{ flex: 1, width: '100%', maxWidth: 400, bgcolor: 'background.paper' }}>
                {rows.map((canal, idx) => (
                    <ListItem 
                        key={idx} 
                        dense 
                        disableGutters 
                        divider
                        secondaryAction={chipStatusCanal(canal)}
                        
                    >
                        <ListItemButton  onClick={() => set(canal)} selected={canal._id === row._id}>
                            <ListItemAvatar>
                                <Avatar>
                                    <Image />
                                </Avatar>
                            </ListItemAvatar>
                            <ListItemText 
                                
                                primary={canal.funcionario.nome} 
                                secondary={formatData(canal.data)} 
                            />
                        </ListItemButton>
                    </ListItem>
                ))}
            </List>
        </Box>
    )
}